import * as React from 'react'
import { FormComponentProps } from 'antd/es/form';
import { Form, Row, Col, Input, Button, Icon, Select, DatePicker, message, Modal } from 'antd';
const Option = Select.Option;
const { confirm } = Modal;
import moment from 'moment';
import _ from "lodash";
// 生成唯一的可识别id
import cuid from "cuid";
import {
  getCustomCost,
  // delCustomOrder,
} from "utils/interface";
import { CQ } from "utils/commonQuest";
// 重写input
import "styles/customOrderInputForm.scss";

interface UserFormProps extends FormComponentProps {
  skuList: any;
  addOrUpdateOrder: any;
  editOrderId: any;
  orderList: any;
  cancelEditForm: any;
  customData: any;
  getSkuList: any;
  getMoney: any;
  money: any;
}

class CustomOrderInputForm extends React.Component<UserFormProps, any> {
  inputDom: Input | null;
  
  constructor(params) {
    super(params);
    this.state = {
      inputFixedWidth : 140,
    }
  }

  componentDidMount () {
    this.fixedInputWidth(); //固定输入框宽度
  }

  fixedInputWidth = () => {
    if(this.inputDom){
      this.setState({
        inputFixedWidth: this.inputDom.input.clientWidth - 9.5
      })
    }
  }

  _getSkuName = (skuid) => {
    let skuName = '';
    if(skuid && this.props.skuList && this.props.skuList.length){
      _.forEach(this.props.skuList, (element) => {
        if(skuid == element.sku_id){
          skuName = element.name;
        }
      })
    }
    return skuName;
  }

  // 检测重复添加sku 校验规则，如果sku和日期相同则提示用户重复添加 
  _checkDuplicateSkuAndDate = (skuId, goTime ) => {
    return _.find(this.props.orderList, (o) => {
      if(skuId == o.sku_id && o.go_time == goTime){
        return true;
      }
      return false;
    });
  }

  _exec = (values) => {
    //如果存在id,则是修改，如果不存在id,则临时生成id
    if(this.props.editOrderId) {
      this.props.addOrUpdateOrder({...values}).then(()=>{
        this.props.cancelEditForm()
        message.success('修改成功!');
      })
    }else{
      this.props.addOrUpdateOrder({...values, id:'temp_' + cuid()});
      message.success('新增一条行程记录!');
    }
  }

  cleanPriceInformation = () => {
    this.props.form.setFieldsValue({
      price:'',
      adult_price:'',
      children_price: '',
      baby_num: '',
      baby_price: '',
      change_cost: '',
      payment: ''
    })
  }

  isEditMode = () => {
    if(this.props.customData && this.props.customData.number){
      return true;
    }else{
      return false;
    }
  }

  _exchangeRate = (changeCost) => {
    if(changeCost){
      if(this.props.money && this.props.money.rate){
        return changeCost * Number(this.props.money.rate);
      }
    }
    return changeCost;
  }
  
  
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if(!err){
        values = {
          ...values, 
          contact_py: values.contact_pinyinSurname + '-' + values.contact_pinyinName,
          sku_name: this._getSkuName(values.sku_id),
          change_cost: this._exchangeRate(values.change_cost)
        }

        let customCostParams:any = {
            sku_id: values.sku_id,
            go_time: moment(values.go_time).format('YYYY-MM-DD'),
            tao_account: values.tao_account
        }
        // 判断是否是
        if(!this.isEditMode()){
          customCostParams = {...customCostParams , group_number: values.group_number}
        }
        const customData = await CQ(getCustomCost(customCostParams))
        if(customData.error){
          message.warning(customData.res.msg);
          return;
        }
        if(this.props.editOrderId) {
          this.props.addOrUpdateOrder({...values}).then(()=>{
            this.props.cancelEditForm()
            this.cleanPriceInformation();
            message.success('修改成功!');
          })
        }else{
          if(this._checkDuplicateSkuAndDate(values.sku_id, moment(values.go_time).format('YYYY-MM-DD'))){
            confirm({
              title: '提示',
              content: '行程单中已经存在此商品，是否继续',
              onOk: () => {
                this.props.addOrUpdateOrder({...values, id:'temp_' + cuid()}).then(()=>{
                  this.cleanPriceInformation();
                });
              },
              onCancel: () => {},
            });
          }else{
            this.props.addOrUpdateOrder({...values, id:'temp_' + cuid()}).then(()=>{
              this.cleanPriceInformation();
            });
          }
          message.success('新增一条行程记录!');
        }
      }
    });
  };

  handleReset = () => {
    this.props.form.resetFields();
  };

  // 遍历数据项
  getData = (data) => {
    let options: any = [];
    if(data && data.length){
      data.forEach((item, index) => {
        // 验证数据格式
        if (!(item && item.sku_id && item.name)) {
          console.warn(
            "格式错误",
            item,
            " 传递给Selector的数据格式应该如此：",
            [{ id: "XXX", name: "XXX" }]
          );
        } else {
          let id = item.sku_id;;
          options.push(
            <Option key={index} value={id}>
              {item.name}{item.tmall_code}
            </Option>
          );
        }
      });
    }
    return options;
  };

  onDatePickerChange = () => {
    
  }

  /**
   特殊逻辑，成人售卖和按数量售卖时，数量为必填。
  */
  _getFixedRule = (key:string) => {
    if(key == 'num' || key == 'adult_num'){
      return [
        {
          required: true,
          message: '不能为空',
        },
        {
          pattern: /^[0-9]+$/,
          message: '只能输入数字',
        }
      ]
    }
    return [
      {
        pattern: /^[0-9]+$/,
        message: '只能输入数字',
      }
    ]
  }

  _genInputItem = (key1:string, text1, key2:string, text2) => {
    const { getFieldDecorator } = this.props.form;
    return (
      <React.Fragment>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(key1, {
                rules: this._getFixedRule(key1),
              })(<Input placeholder={text1} />)}
            </Form.Item>
          </Col>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(key2, {
                rules: [
                  {
                    pattern: /^[-+]?[0-9]*\.?[0-9]+$/,
                    message: '请输入正确的格式',
                  },
                ],
              })(<Input placeholder={text2} prefix="￥" />)}
            </Form.Item>
          </Col>
        </React.Fragment>
    )
  }

  /**
   * 根据当前的sku选择，来控制是显示按人员售卖还是按数量售卖
   */
  genSkuInput = () => {
    let sku_id = this.props.form.getFieldValue('sku_id');
    if(sku_id && this.props.skuList){
      let index = _.findIndex(this.props.skuList, o => { return o.sku_id == sku_id; });
      let selectItem = this.props.skuList[index]
      if(selectItem){
        return (
          <Row gutter={24}>
            {selectItem.num_selected === '1' ? this._genInputItem('num', '数量', 'price', '销售单价') : null }
            {selectItem.adult_selected === '1' ? this._genInputItem('adult_num', '成人数量', 'adult_price', '成人销售价') : null}
            {selectItem.child_selected === '1' ? this._genInputItem('children_num', '儿童数量', 'children_price', '儿童销售价') : null}
            {selectItem.baby_selected === '1' ? this._genInputItem('baby_num', '婴儿数量', 'baby_price', '婴儿销售价') : null}
          </Row>
        )
      }
    }
    return null;
  }

  getInitialValueFromProps = (fieldName) => {
    if(this.props.editOrderId){
      return fieldName;
    }else{
      return ''
    }
  }

  handleGroupNumberChange = async (rule, value, callback) => {
    if(!value){
      callback('定制团号不能为空');
    }
    else if (!/^[a-zA-Z0-9]+$/.test(value)){
      callback('只能输入英文字母和数字');
    }

  }

  handleTaobaoAccountChange = async (rule, value, callback) => {
    if(!value){
      callback('淘宝账号不能为空');
    }
  }

  getGroupNumber = () => {
    const { customData } = this.props;
    const { getFieldDecorator } = this.props.form;
    if(customData && customData.number){
      return (
        <React.Fragment>
          <div style={{display:'flex',height:40,alignItems:'center', justifyContent:'center'}}>
          定制团号：{customData.number}
          </div>
          <Form.Item>
            {getFieldDecorator('group_number', {
          })(<Input type="hidden" />)}
          </Form.Item>
        </React.Fragment>
      )
    }else{
      return(
        <Form.Item>
          {getFieldDecorator('group_number', {
            initialValue: this.getInitialValueFromProps('group_number'),
            rules: [
              { validator: this.handleGroupNumberChange },
            ],
          })(<Input placeholder="定制团号"/>)}
        </Form.Item>
      )
    }
  }

  onSearch = (value: string) => {
    this.props.getSkuList({search: value});
  }

  onChange = (value: string) => {
    this.props.getMoney({sku_id: value});
  }

  render () {
    const { getFieldDecorator } = this.props.form;
    return (
      <React.Fragment>
        <div className="customOrderInputFormTitle">
            <Icon type="snippets" />
            定制单信息
        </div>
      <Form className="ant-advanced-search-form" onSubmit={this.handleSubmit}>
        <div className="specialFormItem">
          {this.getGroupNumber()}
        </div>
        <Row gutter={24}>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`contact_name`, {
                rules: [
                  {
                    required: true,
                    message: '请填写联系人姓名',
                  },
                ],
              })(<Input placeholder="联系人姓名" ref={dom => {this.inputDom = dom}}/>)}
            </Form.Item>
          </Col>
          <Col span={3} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`contact_pinyinSurname`, {
                rules: [
                  {
                    required: true,
                    message: '请填写联系人的姓氏'
                  }
                ],
              })(<Input placeholder="拼音姓" />)}
            </Form.Item>
          </Col>
          <Col span={3} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`contact_pinyinName`, {
                rules: [
                  {
                    required: true,
                    message: '请填写联系人的名',
                  },
                ],
              })(<Input placeholder="拼音名" />)}
            </Form.Item>
          </Col>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`phone`, {
                rules: [
                  {
                    required: true,
                    message: '不能为空',
                  },
                  {
                    pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                    message: '手机号码格式不正确',
                  },
                ],
              })(<Input placeholder="国内手机号"/>)}
            </Form.Item>
          </Col>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`email`, {
                rules: [
                  {
                    required: true,
                    message: '邮件地址格式不正确',
                    type:'email'
                  },
                ],
              })(<Input placeholder="邮箱地址"/>)}
            </Form.Item>
          </Col>
        </Row>
        {/* 第二行 */}
        <Row gutter={24}>
          <Col span={6} style={{ display:'block'}}>
              <Form.Item>
                {getFieldDecorator(`sku_id`, {
                  rules: [
                    {
                      required: true,
                      message: '请选择sku',
                    },
                  ],
                })(
                  <Select
                    style={{ width: this.state.inputFixedWidth }}
                    placeholder={"sku选择"}
                    allowClear={true}
                    // onChange={this.onChange}
                    onSearch={this.onSearch}
                    onChange={this.onChange}
                    // getPopupContainer={this.getContainer}
                    // 检索相关
                    showSearch
                    optionFilterProp="children"
                    dropdownMatchSelectWidth={false}
                    // filterOption={filter}
                    // 检索相关
                  >
                  {this.getData(this.props.skuList)}
                </Select>)}
              </Form.Item>
            </Col>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`go_time`, {
                rules: [
                  {
                    required: true,
                    message: '请选择出发日期',
                  },
                ],
              })(
              <DatePicker 
                onChange={this.onDatePickerChange} 
                placeholder="出发日期"  
                style={{ width: this.state.inputFixedWidth }} 
              />)}
            </Form.Item>
          </Col>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`tao_account`, {
                initialValue: '丁丁_小米',
                rules: [
                  { validator: this.handleTaobaoAccountChange }
                ],
              })(<Input placeholder="淘宝账号" />)}
            </Form.Item>
            <Col span={6}>
            </Col>
          </Col>
        </Row>
        {/* 根据sku显示相应的输入项 */}
        {this.genSkuInput()}
        {/* 第五行 */}
        <Row gutter={24}>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`payment`, {
                rules: [
                  {
                    required: true,
                    message: '请输入实付金额',
                  },
                  {
                    pattern: /^[-+]?[0-9]*\.?[0-9]+$/,
                    message: '请输入正确的格式',
                  },
                ],
              })(<Input placeholder="实付金额" prefix="￥"/>)}
            </Form.Item>
          </Col>  
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`change_cost`, {
                rules: [
                  {
                    pattern: /^[-+]?[0-9]*\.?[0-9]+$/,
                    message: '请输入正确的格式',
                  }
                ],
              })(<Input placeholder="修改成本" prefix={this.props.money.coin} />)}
            </Form.Item>
          </Col>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator('id', {
              })(<Input type="hidden" />)}
            </Form.Item>
          </Col>
          <Col span={6} style={{ display:'block', textAlign: 'right'}}>
            {this.props.editOrderId ? null : 
              <Button type="default" onClick={this.handleReset}>
                重置
              </Button>
            }
            &nbsp;&nbsp;
            <Button type="primary" htmlType="submit">
            {this.props.editOrderId ? '保存修改' : '添加'}
              &nbsp;&nbsp;
            </Button>
          </Col>
        </Row>
      </Form>
      </React.Fragment>
    )
  }
}

 

export default Form.create<UserFormProps>({ name: 'advanced_search' })(CustomOrderInputForm); 